(() => {
  if (window.ctCartExperienceLoaded) return;
  window.ctCartExperienceLoaded = true;

  // These selects live beside the native cart form. Do not let CartItems
  // interpret a product variant ID as a cart quantity change.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ct-card-variant]');
    if (!select) return;
    event.stopPropagation();
    const option = select.selectedOptions[0];
    const card = select.closest('[data-ct-cart-card]');
    if (!option || !card) return;
    card.querySelector('[data-ct-card-price]').textContent = option.dataset.price;
    card.querySelectorAll('[data-ct-card-link]').forEach((link) => { link.href = option.dataset.url; });
    const image = card.querySelector('.ct-cart-card__image img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = option.dataset.imageAlt || '';
    }
    const quantity = select.form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = option.dataset.min || '1';
  }, true);

  if (!customElements.get('ct-cart-recommendations')) {
    customElements.define('ct-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
      disconnectedCallback() { this.unsubscribe?.(); this.request?.abort(); }
      async refresh() {
        this.request?.abort();
        this.request = new AbortController();
        const request = this.request;
        const url = new URL(routes.cart_url, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (request !== this.request || !this.isConnected) return;
          const fresh = html.querySelector('ct-cart-recommendations');
          if (fresh) {
            this.innerHTML = fresh.innerHTML;
            this.hidden = false;
          }
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
    });
  }

  let transitionTimer;
  function resetCheckout() {
    clearTimeout(transitionTimer);
    document.querySelector('.ct-cart-transition')?.remove();
    document.querySelectorAll('.ct-cart-checkout[aria-busy="true"]').forEach((button) => {
      button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('submit', (event) => {
    const button = event.submitter;
    if (!button?.matches('.ct-cart-checkout') || event.defaultPrevented || button.disabled) return;
    resetCheckout();
    button.setAttribute('aria-busy', 'true');
    const overlay = document.createElement('div');
    overlay.className = 'ct-cart-transition';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    const panel = document.createElement('div');
    panel.className = 'ct-cart-transition__panel';
    const orbit = document.createElement('span');
    orbit.className = 'ct-cart-transition__orbit';
    orbit.setAttribute('aria-hidden', 'true');
    const title = document.createElement('strong');
    title.className = 'ct-cart-transition__title';
    title.textContent = 'Preparando tu pedido';
    const copy = document.createElement('p');
    copy.className = 'ct-cart-transition__copy';
    copy.textContent = 'Te llevamos al siguiente paso para completar tus datos.';
    panel.append(orbit, title, copy);
    overlay.append(panel);
    document.body.append(overlay);
    // The form continues its normal native submission immediately. The visual
    // transition never adds merchandise, modifies discounts or claims success.
    transitionTimer = setTimeout(resetCheckout, 12000);
  });
  window.addEventListener('pageshow', resetCheckout);
})();
